import {
  SET_ADD_EXTRA_DISCOUNT_PERCENTAGE,
  SET_ADD_EXTRA_PERCENTAGE,
  SET_GENERAL_DISCOUNT,
  SET_GENERAL_EXPENSES,
  SET_INDIRECT_EXPENSES,
  SET_INDUSTRIAL_PROFIT,
  SET_INITIAL_MARGIN_DATA,
  SET_IS_CLIENT_PRICE,
  SET_OVERRIDE_DISCOUNTS,
  SET_OVERWRITE_MARGIN,
  SET_TOTAL_MARGIN,
  SET_ACCORDION_SELECTED,
  SET_DISCOUNT_ACCORDION_SELECTED,
  SET_OVERWRITE_MARGIN_EXTRA,
  SET_TAB,
  LOADING,
  SET_COST_REDUCTION,
  SET_OVERWRITE_COST_REDUCTION,
} from "context/types"

export const GENERAL = "general"
export const EXTRA = "extra"
export const RUBRO = "rubro"

export const initialMarginsDiscountsState = {
  margins: {
    totalMargin: 0,
    overwrite: false,
    overwriteExtra: false,
    generalExpenses: 0,
    indirectExpenses: 0,
    industrialProfit: 0,
    addExtraPercentage: 0,
    accordionSelected: GENERAL,
  },
  discounts: {
    generalDiscount: 0,
    addExtraDiscountPercentage: 0,
    overrideDiscounts: true,
    accordionSelected: EXTRA,
  },
  formulas: {
    isClientPrice: true,
  },
  bajas: {
    costReduction: 0,
    costReductionOverwrite: false,
  },
  tab: 0,
  loading: false,
}

export const marginsDiscountsReducer = (state, action) => {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        loading: action.payload,
      }

    case SET_TAB:
      return {
        ...state,
        tab: action.payload,
      }

    case SET_INITIAL_MARGIN_DATA:
      return {
        ...state,
        margins: { ...state.margins, ...action.payload.margins },
        discounts: { ...state.discounts, ...action.payload.discounts },
        formulas: { ...state.formulas, ...action.payload.formulas },
      }

    case SET_ACCORDION_SELECTED:
      return {
        ...state,
        margins: { ...state.margins, accordionSelected: action.payload },
      }

    case SET_TOTAL_MARGIN:
      return {
        ...state,
        margins: { ...state.margins, totalMargin: action.payload },
      }

    case SET_OVERWRITE_MARGIN:
      return {
        ...state,
        margins: { ...state.margins, overwrite: action.payload },
      }

    case SET_OVERWRITE_MARGIN_EXTRA:
      return {
        ...state,
        margins: { ...state.margins, overwriteExtra: action.payload },
      }

    case SET_GENERAL_EXPENSES:
      return {
        ...state,
        margins: { ...state.margins, generalExpenses: action.payload },
      }

    case SET_INDIRECT_EXPENSES:
      return {
        ...state,
        margins: { ...state.margins, indirectExpenses: action.payload },
      }

    case SET_INDUSTRIAL_PROFIT:
      return {
        ...state,
        margins: { ...state.margins, industrialProfit: action.payload },
      }

    case SET_ADD_EXTRA_PERCENTAGE:
      return {
        ...state,
        margins: { ...state.margins, addExtraPercentage: action.payload },
      }

    case SET_GENERAL_DISCOUNT:
      return {
        ...state,
        discounts: { ...state.discounts, generalDiscount: action.payload },
      }

    case SET_ADD_EXTRA_DISCOUNT_PERCENTAGE:
      return {
        ...state,
        discounts: {
          ...state.discounts,
          addExtraDiscountPercentage: action.payload,
        },
      }

    case SET_OVERRIDE_DISCOUNTS:
      return {
        ...state,
        discounts: { ...state.discounts, overrideDiscounts: action.payload },
      }

    case SET_DISCOUNT_ACCORDION_SELECTED:
      return {
        ...state,
        discounts: { ...state.discounts, accordionSelected: action.payload },
      }

    case SET_IS_CLIENT_PRICE:
      return {
        ...state,
        formulas: { ...state.formulas, isClientPrice: action.payload },
      }

    case SET_COST_REDUCTION:
      return {
        ...state,
        bajas: {
          ...state.bajas,
          costReduction: action.payload,
        },
      }

    case SET_OVERWRITE_COST_REDUCTION:
      return {
        ...state,
        bajas: {
          ...state.bajas,
          costReductionOverwrite: action.payload,
        },
      }

    default:
      return state
  }
}
